import { useState } from 'react';

import {
  Box,
  Button,
  Grid,
  Table,
  TableBody,
  Typography,
} from '@mui/material';

import { Helmet } from 'react-helmet-async';

import ChangePasswordConfirmation from './ChangeForm';
import FormStyle from '../FormStyle';
import showTableData from '../Functions/showTableData';
import ChangedPasswordWithSuccess from './ChangedPasswordWithSuccess';

function ChangePasswordIndex() {
  // variables
  const [changedSuccessfully, setChangedSuccessfully] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  // functions
  const handleChangePassword = () => {
    setIsEditing(!isEditing);
  };

  // render conditions
  if (isEditing) {
    return (
      <ChangePasswordConfirmation setChangedPasswordSucessfully={setChangedSuccessfully} setIsEditing={setIsEditing} />
    );
  }

  if (changedSuccessfully) {
    return (
      <ChangedPasswordWithSuccess
        setChangedPasswordSucessfully={setChangedSuccessfully}
        setIsEditing={setIsEditing}
      />
    );
  }

  return (
    <div className="main">
      <Helmet>
        <title>パスワード</title>
      </Helmet>
      <main
        style={{
          overflowY: 'auto',
          height: 'calc(100vh - 65px)',
        }}
      >
        <Box className="container-fluid my-1">
          <Box sx={FormStyle.previewHeader}>
            <h1 className="text-bold">パスワード</h1>
            ご登録のパスワードの変更はこちら
          </Box>
          <Box className="card">
            <Box className="card-body">
              <Grid
                container
                justifyContent="center"
              >
                <Grid item xs={12}>
                  <Table className="table-form-setting">
                    <TableBody>
                      {showTableData({
                        ticket: '現在のパスワード',
                        value: '●●●●●●●●',
                      })}
                    </TableBody>
                  </Table>
                </Grid>
                <Grid
                  item
                  xs={12}
                >
                  <Typography
                    fontSize={12}
                    color="gray"
                  >
                    ※ 情報保護のためパスワードは、伏せ字および実際に入力した数と違う桁数を表示させています。
                  </Typography>
                </Grid>
                <Grid item>
                  <Button
                    onClick={handleChangePassword}
                    variant="contained"
                    className="mt-3"
                  >
                    パスワードを変更
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      </main>
    </div>
  );
}
export default ChangePasswordIndex;
